import i18n from 'i18next'
import { initReactI18next } from 'react-i18next'
import * as Localization from 'expo-localization'
import en from './en'
import sv from './sv'

export const SUPPORTED_LOCALES = ['en', 'sv'] as const
export type SupportedLocale = (typeof SUPPORTED_LOCALES)[number]
export const FALLBACK_LOCALE: SupportedLocale = 'en'

export async function initI18n(): Promise<void> {
  if (i18n.isInitialized) return

  const deviceLang = Localization.getLocales()[0]?.languageCode ?? 'en'
  const lng = deviceLang === 'sv' ? 'sv' : 'en'

  await i18n.use(initReactI18next).init({
    resources: {
      en: { translation: en },
      sv: { translation: sv },
    },
    lng,
    fallbackLng: 'en',
    interpolation: { escapeValue: false },
  })
}

export default i18n